"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _enums = require("MeetingsLib/constants/enums");

var defaults = {
  timeRange: new _TimeRange.default(),
  type: _enums.UNAVAILABLE_REASONS.EVENT,
  relatedEventStartTime: null,
  ownerFirstName: null,
  ownerLastName: null,
  ownerEmail: null
};

var _default = (0, _immutable.Record)(defaults, 'TimeRangeWithDescription');

exports.default = _default;
module.exports = exports.default;